import {Application} from '../domain/onBoarding/application';
import {ApplicationBodyEntity} from './ApplicationBodyEntity';
import {ApplicationBody} from '../domain/onBoarding/application-body';

export class ApplicationEntity implements Application {
  confirmedPhoneNumber: boolean;
  editing: boolean;
  body: ApplicationBody;

  constructor() {
    this.confirmedPhoneNumber = false;
    this.editing = false;
    this.body = new ApplicationBodyEntity();
  }

}
